import React from 'react';
import { useTranslation } from 'react-i18next';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
import ShipmentMapModal from '../ShipmentMapModal';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const statusColors = {
  'In-Transit': 'bg-blue-500',
  Delivered: 'bg-green-500',
  Delayed: 'bg-red-500',
  Pending: 'bg-yellow-400',
};

const LiveRouteMonitoring = ({ shipments3, onViewClick, selectedShipments, setSelectedShipments }) => {
  const { t } = useTranslation();

  return (
    <div className="text-white">
      <h2 className="text-2xl font-semibold mb-4 mt-4">{t('dashboard.liveRouteMonitoring')}</h2>

      <div className="flex flex-wrap gap-6">
        {(!shipments3 || shipments3.length === 0) ? (
          <div className="w-full text-center p-8 bg-white/5 rounded-xl border border-white/10 text-gray-300 mt-4">
            {t('orders.noShipmentsFound', { defaultValue: 'No live shipments found.' })}
          </div>
        ) : (
          shipments3.map((shipment, index) => (
            <div key={shipment._id || index} className="bg-white text-black rounded-xl w-full sm:w-80">
              <div className="flex justify-between items-center bg-[#1E1B2E] font-inter text-white text-[14px] px-4 py-2 rounded-t-lg">
                <span>{t('dashboard.shipmentId', { id: shipment.Id })}</span>
                <span className="flex items-center gap-1">
                  <span className={`w-2 h-2 rounded-full ${statusColors[shipment.status] || 'bg-gray-500'}`}></span>
                  {t(`dashboard.status.${shipment.status?.toLowerCase() || ''}`, { defaultValue: shipment.status || 'Unknown' })}
                </span>
              </div>

              <div className="p-4 relative z-0">
                <h3 className="font-bold">{shipment.origin || 'Unknown'} → {shipment.destination || 'Unknown'}</h3>

                <MapContainer
                  center={
                    shipment?.currentLocation?.coordinates?.length === 2
                      ? [shipment.currentLocation.coordinates[1], shipment.currentLocation.coordinates[0]]
                      : [20.5937, 78.9629]
                  }
                  zoom={5}
                  scrollWheelZoom={false}
                  className="h-48 md:h-64 w-full rounded-md mb-3"
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="© OpenStreetMap contributors"
                  />
                  {shipment?.currentLocation?.coordinates?.length === 2 && (
                    <Marker position={[shipment.currentLocation.coordinates[1], shipment.currentLocation.coordinates[0]]} />
                  )}
                  {shipment?.destinationLocation?.coordinates?.length === 2 && (
                    <Marker position={[shipment.destinationLocation.coordinates[1], shipment.destinationLocation.coordinates[0]]} />
                  )}
                  {shipment?.currentLocation?.coordinates?.length === 2 && shipment?.destinationLocation?.coordinates?.length === 2 && (
                    <Polyline
                      positions={[
                        [shipment.currentLocation.coordinates[1], shipment.currentLocation.coordinates[0]],
                        [shipment.destinationLocation.coordinates[1], shipment.destinationLocation.coordinates[0]],
                      ]}
                      color="blue"
                    />
                  )}
                </MapContainer>

                <div className="flex justify-between items-center">
                  <button
                    onClick={() => onViewClick(shipment._id)}
                    className="bg-[#7A3AED] text-white text-sm px-6 py-1 rounded-full"
                    aria-label={t('alt.viewShipment', { id: shipment.Id })}
                  >
                    {t('orders.view')}
                  </button>
                  <button
                    onClick={() => setSelectedShipments(shipment)}
                    className="text-[#7A3AED] border border-[#7A3AED] text-sm px-4 py-1 rounded-full"
                  >
                    {t('orders.viewInFull')}
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <ShipmentMapModal
        shipment={selectedShipments}
        isOpen={!!selectedShipments}
        onClose={() => setSelectedShipments(null)}
      />
    </div>
  );
};

export default LiveRouteMonitoring;